import React from 'react';
import './joinus.scss';
import {Button, HeadingElement} from 'components';
import IMAGE_1 from "assets/home-page/join_us_1.png";
import IMAGE_2 from "assets/home-page/join_us_2.png";
import IMAGE_3 from "assets/home-page/join_us_3.png";
import IMAGE_4 from "assets/home-page/join_us_4.png";
import IMAGE_5 from "assets/home-page/join_us_5.png";
import {ReactComponent as ELEMENT_05} from "assets/home-page/elements/hp_element_05.svg";
import {useNavigate} from "react-router-dom";


export const JoinUs: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className={'home-join'}>
            <ELEMENT_05 className={'home-join_element_05'}/>
            <div className="home-join_wrapper max">
                <div className="home-join_wrapper_left">
                    <HeadingElement/>
                    <h1>Let Us Help You Grow. We Got You.</h1>
                    <p>Become a member today. Its simple, safe and affordable. </p>
                    <div className="home-join_wrapper_left_cta">
                        <Button text={'Join Us'} type={'primary'} onclick={() => navigate('/registration/#')}/>
                        <Button text={'About Us'} type={'secondary'} onclick={() => navigate('/about/#')}/>
                    </div>
                </div>
                <div className="home-join_wrapper_right">
                    <div className="home-join_wrapper_right_container">
                        <div className="home-join_wrapper_right_container_image_1">
                            <img src={IMAGE_1} alt=""/>
                        </div>
                        <div className="home-join_wrapper_right_container_image_2">
                            <img src={IMAGE_2} alt=""/>
                        </div>
                        <div className="home-join_wrapper_right_container_image_3">
                            <img src={IMAGE_3} alt=""/>
                        </div>
                        <div className="home-join_wrapper_right_container_image_4">
                            <img src={IMAGE_4} alt=""/>
                        </div>
                        <div className="home-join_wrapper_right_container_image_5">
                            <img src={IMAGE_5} alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JoinUs;